// helpers/browserDetection.ts

/**
 * Browser and platform detection utilities
 * These replace the is_js library with native browser APIs
 */

const ua = navigator.userAgent.toLowerCase();
const platform = navigator.platform.toLowerCase();

export const browserDetection = {
  // Operating Systems
  windows: (): boolean => platform.includes('win'),
  mac: (): boolean => platform.includes('mac'),

  // Browsers
  chrome: (): boolean => ua.includes('chrome') && !ua.includes('edg'),
  firefox: (): boolean => ua.includes('firefox'),
  safari: (): boolean => ua.includes('safari') && !ua.includes('chrome'),

  // Device Types
  mobile: (): boolean => {
    // Check for mobile/tablet user agents
    return (
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        ua
      ) ||
      // Check for touch support and small screen
      (('ontouchstart' in window || navigator.maxTouchPoints > 0) &&
        window.innerWidth < 768)
    );
  }
};
